import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export function ProtectedRoute() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === "checking") return <AppLoading />;
  if (status === "anonymous") {
    const returnTo = `${location.pathname}${location.search}`;
    return <Navigate to={`/login?returnTo=${encodeURIComponent(returnTo)}`} replace />;
  }
  return <Outlet />;
}

function AppLoading() {
  return (
    <main className="grid min-h-screen place-items-center bg-canvas p-6" aria-busy="true" aria-label="正在检查登录状态">
      <div className="w-full max-w-sm space-y-4">
        <div className="skeleton mx-auto h-12 w-12 rounded-xl" />
        <div className="skeleton mx-auto h-6 w-48" />
        <div className="skeleton h-52 w-full" />
      </div>
    </main>
  );
}
